import React, { Component } from 'react';
import { translate } from 'react-translate';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Title from '@components/Title';
import Container from '@components/Container';
import images from '../../images';
import * as S from './styles';

const ERROR_TYPES = {
  server: {
    title: 'ERRO_LOADING_TITLE',
    description: 'ERRO_LOADING_DESCRIPTION',
    image: images.erroCarregamento,
  },
  front404: {
    title: 'ERRO_404_TITLE',
    description: 'ERRO_404_DESCRIPTION',
    image: images.erro404,
  },
  front400: {
    title: 'ERROR_400_TITLE',
    description: 'ERROR_400_DESCRIPTION',
    image: images.erro404,
  },
};

class ErrorPage extends Component {
  state = {
    errorType: {
      title: '',
      description: '',
    },
    isFrontError: false,
  };

  componentDidMount() {
    const {
      props: {
        location: { search },
        isFrontError,
      },
    } = this;

    const urlParams = new URLSearchParams(search);
    const serverError = urlParams.get('serverError');

    if (serverError === 'true') {
      this.setState({
        errorType: ERROR_TYPES['server'],
      });
    } else if (isFrontError) {
      this.setState({
        errorType: ERROR_TYPES['front400'],
      });
    } else {
      this.setState({
        errorType: ERROR_TYPES['front404'],
      });
    }
  }

  handleRoutes = (scope) => {
    const {
      props: {
        match: { params },
      },
    } = this;

    const code = params.code || 'root';

    if (scope === 'global') {
      return `/${code}/Report/Overview/Global`;
    }
    if (scope === 'listAll') {
      return `/${code}/Report/Listing/Groups`;
    }
    if (scope === 'ranking') {
      return `/${code}/Report/Ranking/Accounts?sort_by=SPEND`;
    }
    if (scope === 'audience') {
      return `/${code}/Report/Audience/Age&Gender`;
    }
    if (scope === 'budget') {
      return `/${code}/Budget/Listing/Groups`;
    }
    if (scope === 'media') {
      return `/${code}/Medias/Approvals`;
    }
  };

  render() {
    const {
      state,
      props: { t },
    } = this;
    const listOfButtons = ['global', 'listAll', 'ranking', 'audience', 'budget', 'media'];

    const newTitle = t(state.errorType.title);
    const newDescription = t(state.errorType.description);

    const newImage = state.errorType.image;

    return (
      <S.Wrapper>
        <Container>
          <S.Content>
            <S.ImageWrapper>
              <img src={newImage} alt="" />
            </S.ImageWrapper>
            <S.ContentInfo>
              <div>
                <Title tag="h1" fontWeight="bold" marginBottom="px10" dataTestId="title">
                  {newTitle}
                </Title>
                <Title tag="h5" fontWeight="normal" marginBottom="px30" dataTestId="description">
                  {newDescription}
                </Title>
              </div>
              <S.Body>
                <p>{t('CHOOSE_PAGE')}</p>
                <div>
                  {listOfButtons.map((item, index) => (
                    <S.Button
                      key={index}
                      data-testid={`button_${index}`}
                      to={this.handleRoutes(item)}
                      replace
                    >
                      {t(item.toUpperCase())}
                    </S.Button>
                  ))}
                </div>
              </S.Body>
            </S.ContentInfo>
          </S.Content>
        </Container>
      </S.Wrapper>
    );
  }
}

ErrorPage.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  match: PropTypes.func.isRequired,
};

ErrorPage.defaultProps = {
  image: images.erro404,
};

export default withRouter(translate('ErrorPage')(ErrorPage));
